<template>
  <div v-if="showWindow">
    <vs-popup classContent="popup-example" title="Update credit card" :active.sync="popupActive">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Unique" v-model="params.unique" disabled/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <label>Status</label>
          <select v-model="params.status" class="inputx w-full" label="Status">
            <option>declined</option>
            <option>approved</option>
          </select>
        </div>
      </div>
       <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <label>Reason</label>
          <select v-model="params.reason" class="form-control inputx w-full">
              <option></option>
              <option>bad pic</option>
              <option>brand</option>
              <option>outdated</option>
              <option>mismatching details</option>
              <option>client request</option>
              <option>wrong doc</option>
              <option>compliance</option>
              <option>suspected fraud</option>
          </select>
        </div>
      </div>
       <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Comment" v-model="params.comment" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <label>Email</label>
          <select v-model="params.checkbox"  class="inputx w-full" label="Email">
            <option>yes</option>
            <option>no</option>
          </select>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('update-verification-status')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>
  <vx-card no-shadow>
    <vs-table max-items="5" pagination :data="tableData">
            <template slot="thead">
                <vs-th>last_updated</vs-th>
                <vs-th>card_type</vs-th>
                <vs-th>name_on_card</vs-th>
                <vs-th>last4_digits</vs-th>
                <vs-th>verification_status</vs-th>
                <vs-th>action</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                   <vs-td :data="data[indextr].updated_at">
                        {{data[indextr].updated_at}}
                    </vs-td>
                    <vs-td :data="data[indextr].card_type">
                        {{data[indextr].card_type}}
                    </vs-td>
                    <vs-td :data="data[indextr].name_on_card">
                        {{data[indextr].name_on_card}}
                    </vs-td>
                    <vs-td :data="data[indextr].last4_digits">
                        {{data[indextr].last4_digits}}
                    </vs-td>
                    <vs-td :data="data[indextr].ver_status">
                        {{data[indextr].ver_status}}
                    </vs-td>
                    <vs-td>
                       <vs-button class="bg-primary-gradient ml-4" type="filled" @click="updateVerStatus(data[indextr].last4_digits)">Update</vs-button>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
  </vx-card>
  </div>
</template>

<script>
import axios from "@/axios.js"
import vSelect from 'vue-select';
import saleStatus from '../../../resources/sale_status.json';
export default {
  data() {
    return {
      popupActive: false,
      params: {},
      saleStatus:saleStatus,
      tableData:[]
    }
  },
  components:{
    'v-select': vSelect,
  },
  computed: {
    showWindow(){
      if(this.$route.path.indexOf('/clients/')!==-1){
        //if(this.fieldsData.length===0)
          this.setData();
        return true;
      }
      return false;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods:{
    sendData: function(type){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', type);
      params.append('email', this.$route.params.email);
      switch(type){
        case 'update-verification-status':{
          params.append('method', 'cc');
          params.append('cc-unique', this.params.unique);
          params.append('comment', this.params.comment);
          params.append('reason', this.params.reason);
          params.append('status', this.params.status);
          params.append('checkbox', this.params.checkbox);
          break;
        }
      }
      this.$vs.loading();
      axios.post("/api/client",params)
      .then((data) => {
        that.setData(true);
        that.$vs.loading.close();
        if(data.data[0].out1==='done!'|| that.successStatuses.indexOf(data.data[0].out1)!==-1){
          that.openAlert('success','Success',data.data[0].out1);
          that.params={};
          that.popupActive = false;
        } else{
          that.openAlert('danger','Failed',data.data[0].out1);
        }
      })
      .catch((data) => { that.$vs.loading.close(); that.openAlert('danger','Failed',data[0].out1); })
    },

    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    updateVerStatus: function(unique){
      this.params.unique = unique;
      this.popupActive=true;
    },
    setData: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 'get-cc');
      params.append('email', this.$route.params.email);
      axios.post("/api/client",params)
      .then((response) => {
        that.tableData.splice(0);
        for(let i in response.data){
          let data = JSON.parse(response.data[i].object);
          this.tableData.push(data);
        }
      })
      .catch((error) => { console.log('error',error) })
    },
  }
}
</script>
